import React, { FC, useEffect, useState } from 'react';
// import { useMerchants } from '../../../store/merchnts/merchants-context';
import './AccountSelector.scss';
import { AccountSelectorModal, getAllMerchants } from './AccountSelectorModal';
import { IModalWindow, ModalWindow } from '../../modal/ModalWindow';
import { useMerchants } from '../../../store/merchnts/merchants-context';
import { setChosenMerchant } from '../../../store/merchnts/actions/merchant';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { Spinner } from '../../Spinner';

export const AccountSelector: FC = () => {
	const { merchantState: { accountList, isAccountListLoading, platformSystem }, dispatch } = useMerchants();
	const savedMerchantId = localStorage.getItem('chosenMerchant');

	const [merchantId, setMerchantId] = useState<string>(savedMerchantId ? savedMerchantId : '');
	const [selectedValue, setSelectedValue] = useState<string>(null);
	const [modalState, setModalState] = useState<IModalWindow>({
		isOpen: false
	});

	const closeModal = (): void => setModalState(prevState => ({ ...prevState, isOpen: false }));

	const openSelectorModal = (): void => {
		setModalState({
      isOpen: true,
      modalTitle: 'Account selector',
      backdrop: 'static',
      size: 'md',
			enableOverflow: false,
      content: (
        <AccountSelectorModal
          setSelectedValue={setSelectedValue}
          closeModal={closeModal}
          merchantId={merchantId}
          setMerchantId={setMerchantId}
        />
      ),
      contentClassName: 'd-block'
    });
	};

	useEffect(() => {
		if (savedMerchantId) {
			const res = getAllMerchants(accountList)?.find(el => el?.merchantId === savedMerchantId);
			setSelectedValue(res?.dba ? res?.dba : res?.merchantId);
		} else {
			setSelectedValue(null);
		}
	}, [accountList]);

	useEffect(() => {
		setChosenMerchant(dispatch, merchantId);
	}, [merchantId]);

	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent): void => {
			if (e.metaKey && e.key === 'm' && !isAccountListLoading) {
				openSelectorModal();
			} else if (e.ctrlKey && e.key === 'm' && !isAccountListLoading) {
				openSelectorModal();
			}
		};


		window.addEventListener('keydown', handleKeyDown);

		return () => {
			window.removeEventListener('keydown', handleKeyDown);
		};
	}, [merchantId, isAccountListLoading]);

	const handleClean = (e): void => {
		e.stopPropagation();
		localStorage.removeItem('chosenMerchant');
		setSelectedValue(null);
		setMerchantId('');
	};

	const getInputText = (): JSX.Element | string => {
		if (isAccountListLoading) {
			return <Spinner/>;
		}
		if (selectedValue) {
			return selectedValue;
		} else {
			return `Select merchant ${platformSystem === 'windows' ? '(Ctrl+M)' : '(Cmd+M)'}`;
		}
	};

	return (
		<>
			<div
				className={clsx(
					'form-control form-control-solid selector-container-width position-relative',
					isAccountListLoading ? 'cursor-not-allowed' : 'cursor-pointer',
					selectedValue && 'd-flex align-items-center justify-content-between'
				)}
					onClick={(): void => !isAccountListLoading && openSelectorModal()}
			>
				<div className="fc-text-overflow w-100 me-5">
					{getInputText()}
				</div>
					{selectedValue && (
						<div onClick={handleClean} className='merchants-selector-close-icon'>
							<FontAwesomeIcon
								icon={faXmark}
								className="h-15px"
								width={10}
							/>
						</div>
					)}
			</div>
			<ModalWindow
				{...modalState}
				onClose={closeModal}
			/>
		</>
	);
};
